export default __webpack_public_path__ + "static/media/Cooking-hover.ca986fa9.svg";